import {setHours, startOfHour} from 'date-fns';

import {clamp} from 'ramda';

import {TEST_DRIVE_CALENDAR} from '../constants/TEST_DRIVE_CALENDAR';

type ClampedDriveSegment = {
  start: Date;
  end: Date;
  isClampedStart: boolean;
  isClampedEnd: boolean;
};

/** Clamps against the segment's own day, so a midnight-split drive gets per-piece bounds. */
export const clampToBusinessWindow = (start: Date, end: Date): ClampedDriveSegment => {
  const windowStart = startOfHour(setHours(start, TEST_DRIVE_CALENDAR.BUSINESS_START_HOUR));
  const windowEnd = startOfHour(setHours(start, TEST_DRIVE_CALENDAR.BUSINESS_END_HOUR));

  return {
    start: clamp(windowStart, windowEnd, start),
    end: clamp(windowStart, windowEnd, end),
    isClampedStart: start < windowStart || start > windowEnd,
    isClampedEnd: end > windowEnd || end < windowStart,
  };
};
